import bFormFile from './form-file.vue';

export default bFormFile;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/form-file/form-file.js
// module id = 478
// module chunks = 0